import { render, staticRenderFns } from "./PayStarTransaction.vue?vue&type=template&id=e8830826&scoped=true&"
import script from "./PayStarTransaction.vue?vue&type=script&lang=js&"
export * from "./PayStarTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8830826",
  null
  
)

export default component.exports